import React, { useEffect, useMemo, useRef, useState } from "react";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { PropTypes } from "prop-types";
import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";

//components
import AppHoc from "../../../../../generics/AppHOC";

//reducers
import * as actions from "../actions";

//style
import css from "../../../reportsMagneticStyle.less";

//utils
import { getColumns } from "../../../../app360/SiteList/hbrTableConfig";
import { useI18n } from "../../../../../i18n/useI18n";
import useColumns from "@harbor/elements/utils/table/hooks/columns";
import TableStore from "@harbor/elements/utils/table/store";
import NoData from "../../../../../common/table/NoData";
import { formatRequestPayload } from "../../../../../utils/query-utils";
import { sortdata } from "../../../../../utils/common";
import { formatBytes } from "../../../../../utils/format";

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

const mapStateToProps = (state) => {
  return {
    app360: state.vanalytics.app360_report,
  };
};

const [HbrCard, HbrTable] = reactWrapper(["hbr-card", "hbr-table"]);
const tableId = "topsites_table";

const SiteList = (props) => {
  const [loader, setLoader] = useState(true);
  const [, forceUpdate] = useState({}); // Used to trigger re-render from TableStore
  const siteData = props.sitesData;
  const { tViews } = useI18n("views");
  const tableRef = useRef({ error: null }); // Track fetch error
  const isReportView = true;

  const columnsHook = useColumns({
    config: ({ store }) => getColumns(props, tViews, isReportView, store),
  });

  const tableStore = useMemo(() => {
    return new TableStore({
      query: { page: 0, pageLength: 50 },
      hooks: [columnsHook],
      fetchData: async (query) => {
        setLoader(true);
        try {
          const rawData = siteData;
          const sortedData = (rawData || []).map((item) => ({ ...item }));
          sortedData.forEach((item) => {
            if ("usage" in item) {
              item.usage = formatBytes(item.usage);
            }
          });
          const requestPayload = formatRequestPayload(
            {},
            siteData,
            tableRef.current?.table
          );
          const finalData = sortdata(requestPayload, sortedData);
          query.setSource(finalData);
          query.setCount(finalData.length || 0);
        } catch (error) {
          console.error("Error fetching sites list table:", error);
          tableRef.current.error = error;
          query.setSource([]);
          query.setCount(0);
        } finally {
          setLoader(false);
        }
      },
    });
  }, [siteData]);

  useEffect(() => {
    const unsubscribe = tableStore.subscribe(() => forceUpdate({}));
    return () => unsubscribe();
  }, [tableStore]);
  const { source, columns, query } = tableStore.getState();
  const { pageLength } = query;

  return (
    <div
      className={css["app360-report-sites-list-table"]}
      data-cy="app360-report-sites-list-table"
    >
      <HbrCard>
        <div className="site-list-table" data-cy="site-list-table-view">
          <HbrTable
            id={tableId}
            data-testid={tableId}
            columns={columns}
            source={source}
            style={{
              minHeight: "300px",
              height: `${source.length * 37.5}px`,
            }}
            serverSide
            externalSorting
            readonly
            resize
            frameSize={pageLength}
            canFocus={false}
            useClipboard={false}
            headerSlot
            role="table"
            onHbr-before-sort={(event) => {
              const { column, order } = event.detail;
              const columnsHook = tableStore.getHook("columns");
              if (order) {
                columnsHook.sort({ order: [[column.id, order]] });
              }
            }}
          >
            <NoData
              count={source.length}
              loader={loader}
              error={tableRef.current.error}
            />
          </HbrTable>
        </div>
      </HbrCard>
    </div>
  );
};

SiteList.propTypes = {
  app360: PropTypes.object.isRequired,
  actions: PropTypes.object,
  sitesData: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppHoc(SiteList));
